export const RESET_LAUNCH = 'RESET_LAUNCH';
export const SET_SAML_METHOD = 'SET_SAML_METHOD';
export const SET_SAML_BODY = 'SET_SAML_BODY';
export const SET_REDIRECT_AFTER_SIGNIN = 'SET_REDIRECT_AFTER_SIGNIN';
